import styled from "styled-components"
import {useState} from 'react';
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
function Search() {

    const [input, setInput] = useState("");
    const navigate = useNavigate();

    const submitHandler = (e) =>{
        e.preventDefault();
        navigate("/searched/"+input);
    };
  return (
   <FromStyle onSubmit={submitHandler}>
    <div>
    <FaSearch></FaSearch>
    <input onChange={(e) => setInput(e.target.value)}  type="text" value={input} />
    </div>
   </FromStyle>
  );
}

const FromStyle = styled.form`
  margin: 0rem 20rem;

  div {
    position: relative;
    width: 100%;
  }

  input {
    border: none;
    background: linear-gradient(35deg, #494949, #313131);
    font-size: 1.5rem;
    color: white;
    padding: 1rem 3rem;
    border-radius: 1rem;
    outline: none;
    width: 100%;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(100%, -50%);
    color: white;
  }

  @media (max-width: 768px) {
    margin: 0rem 10rem;
    input {
      font-size: 1.2rem;
      padding: 0.8rem 2rem;
    }
  }

  @media (max-width: 576px) {
    margin: 0rem 5rem;
    input {
      font-size: 1rem;
      padding: 0.6rem 1.5rem;
    }
  }
`;

export default Search